// Dependecies
import { useState } from 'react';

// Store
import driverRegister from '../../store/driverRegister';
import user from '../../store/user';

function UsePopUpDriverUpdate(success) {
  const [, driverActions] = driverRegister();
  const [userStore] = user();
  const [messageErrorEmail, setMessageErrorEmail] = useState(false);
  const [messageErrorId, setMessageErrorId] = useState(false);
  const [errorApi, setErrorApi] = useState(false);

  const submit = (data, id) => {
    try {
      const dat = {
        ...data,
        id,
      };
      driverActions.update(dat, userStore.token).then(
        (res) => {
          if (res.status === 200) {
            success(true);
            setMessageErrorEmail(false);
            setMessageErrorId(false);
          }
          if (res.status === 400) {
            setMessageErrorEmail(true);
          }
          if (res.status === 401) {
            setMessageErrorId(true);
          }
        },
        (e) => {
          setErrorApi(e);
        }
      );
    } catch (error) {
      setErrorApi(error);
    }
  };

  return {
    submit,
    messageErrorEmail,
    messageErrorId,
    errorApi,
  };
}

export default UsePopUpDriverUpdate;
